export const storeProducts = [
  {
    id: 1,
    title: "Japan MG",
    img: "productImgs/japan one MG.jfif",
    price: 45.00,
    company: "MAGZ STUDIOS",
    info:
      "Taki and Mitsuha lost in Japan",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 2,
    title: "Of Pink MG",
    img: "productImgs/of pink MG.jfif",
    price: 45.00,
    company: "MAGZ STUDIOS",
    info:
      "Arjun's favorite color is Pink",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 3,
    title: "Butterfly MG",
    img: "productImgs/small blk butterfly MG.jfif",
    price: 45.00,
    company: "MAGZ STUDIOS",
    info:
      "ThienAn's favorite animal is butterflies",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 4,
    title: "Big Butterfly MG",
    img: "productImgs/bg wt butterfly MG.jfif",
    price: 35.00,
    company: "MAGZ STUDIOS",
    info:
      "If you buy this one, you're from a different gang",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 5,
    title: "Lavender Love MG",
    img: "productImgs/lav pink MG.jfif",
    price: 24.00,
    company: "MAGZ STUDIOS",
    info:
      "Lavender is BEAUTIFUL",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 6,
    title: "Long Grey Japan MG",
    img: "productImgs/grey long MG.jfif",
    price: 17.00,
    company: "MAGZ STUDIOS",
    info:
      "MAGZ",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 7,
    title: "Red Comit Japan MG",
    img: "productImgs/comit japan MG.jfif",
    price: 37.00,
    company: "MAGZ STUDIOS",
    info:
      "It's a Derk style.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 8,
    title: "wHole Japan MG",
    img: "productImgs/holeJapMG.jfif",
    price: 50.00,
    company: "MAGZ STUDIOS",
    info:
      "It's a vibe.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 9,
    title: "HARBOUR MAGZ",
    img: "productImgs/harbourMagz.png",
    price: 50.00,
    company: "MAGZ STUDIOS",
    info:
      "Mushu likes it so . . . http://www.ooshirts.com/designapp/sharing/5265647804 ",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 10,
    title: "BoJack MagzMan COMING SOON",
    img: "productImgs/BoJack MagzMan coming soon.jpg",
    price: 47.00,
    company: "MAGZ STUDIOS",
    info:
      "BoJack MagzMan. The View From Half Way Down.",
    inCart: false,
    count: 0,
    total: 0
  }
  
];

export const detailProduct = {
  id: 1,
  title: "Japan MG",
  img: "productImgs/japan one MG.jfif",
  price: 45.00,
  company: "MAGZ STUDIOS",
  info:
    "Taki and Mitsuha lost in Japan",
  inCart: false,
  count: 0,
  total: 0
};
